export default __webpack_public_path__ + "static/media/goshen53.9b108c14.JPG";